/* eslint-disable no-unused-expressions */
import { useEffect, useRef, forwardRef, ForwardRefRenderFunction, ReactNode, MutableRefObject } from 'react'
import { createPortal } from 'react-dom'
import './Modal.scss'

interface Props {
  children: ReactNode
  extraClass?: string
}

const modalRoot = document.getElementById('root')

const Modal: ForwardRefRenderFunction<ReactNode, Props> = ({ children, extraClass }, ref) => {
  const elRef = useRef<HTMLDivElement>(document.createElement('div'))
  const extra = extraClass || ''
  // https://github.com/DefinitelyTyped/DefinitelyTyped/issues/35572
  const castedRef = ref as unknown as MutableRefObject<HTMLDivElement>

  useEffect(() => {
    const myRef = elRef.current
    modalRoot?.appendChild(myRef)
    return (): void => {
      modalRoot?.removeChild(myRef)
    }
  }, [])

  useEffect(() => {
    document.body.classList.add('keep-scroll')
    return (): void => {
      document.body.classList.remove('keep-scroll')
    }
  })

  return createPortal(
    <div className={`Modal ${extra}`} ref={castedRef}>
      {children}
    </div>,
    elRef.current,
  )
}

export default forwardRef(Modal)
